module.exports = __webpack_public_path__ + "img/logo-tw.2fedb6d0.svg";